import requests from "./httpServices.js";

class CommonFolderService {
  /**
   * Get all common folders
   * @returns Promise<CommonFoldersResponse>
   */
  async getCommonFolders() {
    try {
      const response = await requests.get(`/v1/common-folders`);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get a single common folder by ID
   * @param folderId - Common folder ID
   * @returns Promise<CommonFolderResponse>
   */
  async getCommonFolderById(folderId) {
    try {
      const response = await requests.get(`/v1/common-folders/${folderId}`);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get common elements by folder ID
   * @param folderId - Common folder ID
   * @returns Promise<CommonElementsResponse>
   */
  async getCommonElementsByFolderId(folderId) {
    try {
      const response = await requests.get(`/v1/common-elements/folder/${folderId}`);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get common files by folder ID
   * @param folderId - Common folder ID
   * @returns Promise<CommonFilesResponse>
   */
  async getCommonFiles(folderId) {
    try {
      const response = await requests.get(`/v1/common-files/${folderId}`);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Handle API errors
   * @param error - Error object
   * @returns Error with formatted message
   */
  handleError(error) {
    if (error.response?.data) {
      const { message, errors } = error.response.data;

      if (errors && typeof errors === "object") {
        // Handle validation errors
        const errorMessages = Object.values(errors).flat();
        return new Error(errorMessages.join(", "));
      }

      if (message) {
        return new Error(message);
      }
    }

    if (error.message) {
      return new Error(error.message);
    }

    return new Error("An unexpected error occurred");
  }
}

// Export singleton instance
const commonFolderService = new CommonFolderService();
export default commonFolderService;
